import React from "react";
import styled from "styled-components";
import TonginLogoIcon from "../../icon/tonginLogo";
import { Image } from "../image";
import { toDate } from "date-fns";
import CustomButton from "../customButton";
import { text } from "stream/consumers";
import {
  convertMattressContractImg,
  convertPlumberContractImg,
} from "../../../API/AppRepository";
import { useNavigate, useParams } from "react-router-dom";

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;

  /* 모바일*/
  @media (max-width: 767px) {
    padding: 0px;
    gap: 10px;
  }

  /* 태블릿*/
  @media (min-width: 768px) and (max-width: 1199px) {
    padding: 20px 10px;
    gap: 20px;
  }

  /* PC */
  @media (min-width: 1200px) {
    padding: 20px 10px;
    gap: 20px;
  }
`;

const ButtonArea = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;

  /* 모바일*/
  @media (max-width: 767px) {
    height: 40px;
  }

  /* 태블릿*/
  @media (min-width: 768px) and (max-width: 1199px) {
    height: 60px;
  }

  /* PC */
  @media (min-width: 1200px) {
    height: 70px;
  }
`;

const ContractContainer = styled.div`
  background: #fff;
  border: 1px solid #ccc;
  font-family: "Pretendard", sans-serif;
  font-size: 16px;
  color: #000;
  display: flex;
  flex-direction: column;
  gap: 10px;
  box-sizing: border-box;

  /* 모바일*/
  @media (max-width: 767px) {
    width: 100%;
    height: calc(width * 1.414);
    padding: 16px;
  }

  /* 태블릿*/
  @media (min-width: 768px) and (max-width: 1199px) {
    width: 100%;
    min-height: 1123px;
    padding: 40px;
  }

  /* PC */
  @media (min-width: 1200px) {
    width: 794px;
    min-height: 1123px;
    padding: 40px;
  }
`;

const Title = styled.h1`
  font-weight: bold;
  text-align: end;

  /* 모바일*/
  @media (max-width: 767px) {
    margin-bottom: 4px;
    font-size: 16px;
  }

  /* 태블릿*/
  @media (min-width: 768px) and (max-width: 1199px) {
    margin-bottom: 12px;
    font-size: 28px;
  }

  /* PC */
  @media (min-width: 1200px) {
    margin-bottom: 12px;
    font-size: 28px;
  }
`;
const SubTitle = styled.h3`
  font-weight: normal;
  text-align: end;

  /* 모바일*/
  @media (max-width: 767px) {
    font-size: 9px;
  }

  /* 태블릿*/
  @media (min-width: 768px) and (max-width: 1199px) {
    font-size: 12px;
  }

  /* PC */
  @media (min-width: 1200px) {
    font-size: 12px;
  }
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;

  /* 모바일*/
  @media (max-width: 767px) {
    margin-top: 0px;
  }

  /* 태블릿*/
  @media (min-width: 768px) and (max-width: 1199px) {
    margin-top: 12px;
  }

  /* PC */
  @media (min-width: 1200px) {
    margin-top: 12px;
  }

  th,
  td {
    border: 1px solid #333;

    text-align: left;

    /* 모바일*/
    @media (max-width: 767px) {
      padding: 2px 4px;
      font-size: 10px;
      font-weight: 300;
    }

    /* 태블릿*/
    @media (min-width: 768px) and (max-width: 1199px) {
      padding: 8px 12px;
      font-size: 16px;
      font-weight: 300;
    }

    /* PC */
    @media (min-width: 1200px) {
      padding: 8px 12px;
      font-size: 16px;
      font-weight: 300;
    }
  }

  th {
    background: #f4f4f4;
  }
`;

const Section = styled.div`
  margin-bottom: 24px;
`;

const Title2 = styled.div`
  /* 모바일*/
  @media (max-width: 767px) {
    font-size: 12px;
    margin-bottom: 4px;
  }

  /* 태블릿*/
  @media (min-width: 768px) and (max-width: 1199px) {
    font-size: 16px;
    margin-bottom: 10px;
  }

  /* PC */
  @media (min-width: 1200px) {
    font-size: 16px;
    margin-bottom: 10px;
  }
`;

const NoteBox = styled.div`
  border: 1px dashed #aaa;
  min-height: 80px;
  margin-bottom: 12px;

  /* 모바일*/
  @media (max-width: 767px) {
    font-size: 10px;
    padding: 6px;
    min-height: 60px;
  }

  /* 태블릿*/
  @media (min-width: 768px) and (max-width: 1199px) {
    font-size: 16px;
    padding: 16px;
    min-height: 80px;
  }

  /* PC */
  @media (min-width: 1200px) {
    font-size: 16px;
    padding: 16px;
    min-height: 80px;
  }
`;

const Footer = styled.div`
  text-align: center;

  /* 모바일*/
  @media (max-width: 767px) {
    font-weight: bold;
    margin-top: 20px;
    font-size: 14px;
  }

  /* 태블릿*/
  @media (min-width: 768px) and (max-width: 1199px) {
    font-weight: bold;
    margin-top: 48px;
    font-size: 20px;
  }

  /* PC */
  @media (min-width: 1200px) {
    font-weight: bold;
    margin-top: 48px;
    font-size: 20px;
  }
`;

const Footer2 = styled.div`
  text-align: center;

  /* 모바일*/
  @media (max-width: 767px) {
    font-weight: 300;
    margin-top: 10px;
    font-size: 9px;
  }

  /* 태블릿*/
  @media (min-width: 768px) and (max-width: 1199px) {
    font-weight: 300;
    margin-top: 16px;
    font-size: 12px;
  }

  /* PC */
  @media (min-width: 1200px) {
    font-weight: 300;
    margin-top: 16px;
    font-size: 12px;
  }
`;

const LogoImg = styled.div`
  display: flex;
  justify-content: start;
  align-items: end;
  /* 모바일*/
  @media (max-width: 767px) {
    width: 120px;
    height: 34px;
    padding-left: 4px;
  }

  /* 태블릿*/
  @media (min-width: 768px) and (max-width: 1199px) {
    width: 200px;
    height: 60px;
    padding-left: 10px;
  }

  /* PC */
  @media (min-width: 1200px) {
    width: 200px;
    height: 60px;
    padding-left: 10px;
  }
`;
const StampArea = styled.div`
  margin-top: 1vw;
  display: flex;
  justify-content: center;
  width: 100%;
  height: 5vw;
`;

const ComponyNameTitle = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  /* 모바일*/
  @media (max-width: 767px) {
    font-size: 16px;
    font-weight: 700;
  }

  /* 태블릿*/
  @media (min-width: 768px) and (max-width: 1199px) {
    font-size: 30px;
    font-weight: 700;
  }

  /* PC */
  @media (min-width: 1200px) {
    font-size: 30px;
    font-weight: 700;
  }
`;

const StampBox = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  /* 모바일*/
  @media (max-width: 767px) {
    width: 26px;
    height: 26px;
  }

  /* 태블릿*/
  @media (min-width: 768px) and (max-width: 1199px) {
    width: 50px;
    height: 50px;
  }

  /* PC */
  @media (min-width: 1200px) {
    width: 50px;
    height: 50px;
  }
`;

const HeaderArea = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const TitleArea = styled.div`
  display: flex;
  flex-direction: column;
  align-items: end;
  justify-content: start;
`;

const toDay = new Date();
const formatted = `${toDay.getFullYear()}-${String(
  toDay.getMonth() + 1
).padStart(2, "0")}-${String(toDay.getDate()).padStart(2, "0")}`;

interface Props {
  form: {
    name: string;
    status: string;
    contact: string;
    itemCode: string;
    address: string;
    addressDetail: string;
    zipCode: string;
    workDate: string;
    totalPrice: number;
    memo: string;
  };
  options: { label: string; size: number; price: number }[];
}

export default function MattressDetailExportInfo({ form, options }: Props) {
  const { id } = useParams();
  const navigate = useNavigate();

  const sendContractImageHandler = async (e: any) => {
    if (!id) {
      alert("ID가 없습니다. 다시 시도해주세요.");
      return;
    }
    const result = await convertMattressContractImg(
      e,
      id,
      ".mattressContractPage"
    );

    alert("전송이 완료되었습니다.");
    navigate(`/mattress`);
  };

  return (
    <Wrapper>
      <ContractContainer className="mattressContractPage">
        <HeaderArea>
          <LogoImg>
            <Image
              src="/icon/tonginLogo.png"
              width={"100%"}
              height={"100%"}
            ></Image>
          </LogoImg>
          <TitleArea>
            <Title>매트리스케어 견적서</Title>
            <SubTitle>DATE : {formatted}</SubTitle>
          </TitleArea>
        </HeaderArea>
        <Section>
          <Table>
            <tbody>
              <tr>
                <th>고객명</th>
                <td>{form.name}</td>
                <th>작업일</th>
                <td>{form.workDate.slice(0, 10)}</td>
              </tr>
              <tr>
                <th>연락처</th>
                <td>{form.contact}</td>
                <th>상품명</th>
                <td>배관케어({form.itemCode})</td>
              </tr>
              <tr>
                <th>작업주소</th>
                <td colSpan={3}>
                  {form.address} ({form.zipCode})
                </td>
              </tr>
              <tr>
                <th>상세주소</th>
                <td colSpan={3}>{form.addressDetail}</td>
              </tr>
            </tbody>
          </Table>
        </Section>

        <Section>
          <Title2>2. 옵션 품목</Title2>
          <Table>
            <thead>
              <tr>
                <th style={{ textAlign: "center", width: "40%" }}>품명</th>
                <th style={{ textAlign: "center", width: "20%" }}>단위</th>
                <th style={{ textAlign: "center", width: "25%" }}>금액(원)</th>
                <th style={{ textAlign: "center", width: "15%" }}>비고</th>
              </tr>
            </thead>
            <tbody>
              {options.map((opt, idx) => (
                <tr key={idx}>
                  <td style={{ textAlign: "center" }}>{opt.label}</td>
                  <td style={{ textAlign: "center" }}>{opt.size}</td>
                  <td style={{ textAlign: "right" }}>
                    {opt.price.toLocaleString()}
                  </td>
                  <td></td>
                </tr>
              ))}
              <tr>
                <td
                  colSpan={2}
                  style={{ textAlign: "center", fontWeight: "bold" }}
                >
                  합계
                </td>
                <td style={{ textAlign: "right", fontWeight: "bold" }}>
                  {form.totalPrice.toLocaleString()}
                </td>
                <td style={{ textAlign: "center" }}>VAT별도</td>
              </tr>
            </tbody>
          </Table>
        </Section>

        <Section>
          <Title2>3. 메모</Title2>
          <br />
          <NoteBox>{form.memo || ""}</NoteBox>
        </Section>

        <Footer>
          상기와 같이 견적을 제시합니다.
          <br />
          <Footer2>We hereby submit Quotation as above.</Footer2>
          <br />
          <br />
          <StampArea>
            <ComponyNameTitle> (주)통인홈네트웍스 </ComponyNameTitle>
            <StampBox>
              <Image
                src="/img/stamp.png"
                width={"100%"}
                height={"100%"}
              ></Image>
            </StampBox>
          </StampArea>
        </Footer>
      </ContractContainer>
      <ButtonArea>
        <CustomButton
          width="100%"
          height="100%"
          text="견적서 내보내기"
          $bgColor="#0C8CE9"
          onClick={(e: any) => sendContractImageHandler(e)}
        ></CustomButton>
      </ButtonArea>
    </Wrapper>
  );
}
